// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-item-group[data-v-5086efd7],.v-menu__content[data-v-5086efd7]{background-color:#fff!important}", ""]);
// Exports
module.exports = exports;
